<template>
  <div class="mx-auto container my-12">
    <div class="grid grid-cols-3 grid-cols-1 gap-8">
      <div class="w-full z-index1" v-for="item in cards" :key="item.objectId">
        <img
          :src="item.image"
          alt="Grid"
          class="mx-auto py-4 lg:h-24 md:h-24 h-24 lg:w-24 md:w-24 w-24 effect-hol object-contain"
        />
        <h1
          class="font-semibold lg:text-lg md:text-lg text-base text-center mt-2"
        >
          {{ item.title }}
        </h1>
        <!-- <p class="text-sm text-center text-gray my-4 px-7">
          {{ item.description }}
        </p> -->
      </div>
    </div>
    <div class="border my-4 rounded-lg p-3 lg:mb-12 md:mb-12">
      <h3 class="fsize22 font-semibold">Disclaimer:</h3>
      <p class="leading-tight fsize16 mt-3 clr-2e2e2e">
        Please note that the products and services available on Caregiver
        Saathi's shop may involve direct payments or affiliate partnerships. For
        items requiring payment, terms and conditions, including payment
        methods, cancellations, and refunds, are governed by the respective
        product manufacturer or service provider.
      </p>
      <p class="fsize16 mt-1 clr-2e2e2e">
        The minimum delivery time is one week, while the maximum delivery time
        is four weeks.
      </p>
      <p class="fsize16 leading-tight mt-2 clr-2e2e2e">
        All the paid services and products are being managed and provided by
        Karuna Tech Services Private Limited(KTSPL).
      </p>
      <p class="fsize16 mt-2 clr-2e2e2e">
        For any queries or assistance regarding your purchase, please contact us
        at:
      </p>
      <p class="fsize16 font-medium clr-2e2e2e">
        Phone: <a href="tel:9619962168">9619962168</a>
      </p>
      <p class="fsize16 font-medium clr-2e2e2e">
        Email:
        <a href="mailto:services@caregiversaathi.co.in"
          >services@caregiversaathi.co.in</a
        >
      </p>
      <p class="fsize16 font-medium mt-2 clr-2e2e2e">
        Operational Address:
        <br />
        HD-093, WeWork Oberoi Commerz II, 1st Floor CTS No 95, 4B 3 and 4 590,
        W.E Highway, Oberoi Garden City, Goregaon (E), MUMBAI SUBURBAN,
        District: Mumbai, State: Maharashtra - 400063
      </p>
      <p class="fsize16 font-medium clr-2e2e2e">
        (c) Telephone number of the person/association(with STD Code):
        09833312168
      </p>
      <p class="fsize16 leading-tight mt-2 clr-2e2e2e">
        We are committed to providing you with the best shopping experience and
        will address any concerns promptly. Thank you for shopping with us!
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cards: [
        {
          title: "Secure Payments",
          image: require("@/assets/images/ecommerce/EcommIcons1.png"),
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor tempore inventore pariatur sint doloremque excepturi ",
        },
        {
          title: "Great Value & Quality",
          image: require("@/assets/images/ecommerce/EcommIcons2.png"),
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor tempore inventore pariatur sint doloremque excepturi ",
        },
        {
          title: "Shipping in India",
          image: require("@/assets/images/ecommerce/EcommIcons3.png"),
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor tempore inventore pariatur sint doloremque excepturi ",
        },
      ],
    };
  },
};
</script>
